import { render, staticRenderFns } from "./TeamBoardActionListWaitApproveMessage.vue?vue&type=template&id=4a13f2f1&"
import script from "./TeamBoardActionListWaitApproveMessage.vue?vue&type=script&lang=ts&"
export * from "./TeamBoardActionListWaitApproveMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports